import { useQuery } from '@tanstack/react-query';
import {
  PathType,
  type LearningPathsResponse,
  type PathResponse,
} from '@/data/learning-path/interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/learning-path/base';

const PATHS_PAGE_SIZE = 12;

export const usePathsByScope = ({
  scope,
  page = 1,
}: {
  scope: PathType;
  page?: number;
}) => {
  const response = useQuery<LearningPathsResponse>({
    queryKey: [clientKeys.usePathsByScope, scope, page],
    queryFn: async () =>
      await falconClient.get(`${baseUrl}/paths`, {
        params: {
          scope,
          per_page: PATHS_PAGE_SIZE,
          page,
        },
      }),
  });

  return {
    paths: response.data?.learning_paths ?? [],
    metadata: response.data?.metadata,
    ...response,
  };
};

export const usePathsIndex = () => {
  const response = useQuery<LearningPathsResponse>({
    queryKey: [clientKeys.usePathsIndex],
    queryFn: async () => await falconClient.get(`${baseUrl}/paths`),
  });

  const globalPaths = response?.data?.learning_paths?.filter(
    (path) => path.global
  );
  const companyPaths = response?.data?.learning_paths?.filter(
    (path) => !path.global
  );
  const hasCompanyPaths =
    (companyPaths?.length && companyPaths.length > 0) || false;

  return {
    companyPaths,
    globalPaths,
    hasCompanyPaths,
    ...response,
  };
};

export const useShowPath = ({ pathId }: { pathId: string }) => {
  const response = useQuery<PathResponse>({
    queryKey: [clientKeys.useShowPath, pathId],
    queryFn: async () => await falconClient.get(`${baseUrl}/paths/${pathId}`),
  });

  const path = response?.data?.learning_path;

  return { path, ...response };
};
